import values from 'lodash/values'
import { createSelector } from 'reselect'

import { makeSortGroups } from 'Global/Helpers/groupHelpers'

const _groups = state => state.groups.data
const _page = state => state.layout.groups.page

export const createdGroup = state => state.groups.create.createdGroup
export const groupsDone = state => state.groups.done
export const groupsError = state => state.groups.error
export const groupsPending = state => state.groups.pending
export const limit = state => state.layout.groups.limit
export const sortBy = state => state.layout.groups.sortBy
export const sortOrder = state => state.layout.groups.sortOrder
export const user = state => state.auth.user

export const filterGroups = createSelector(
  [sortBy, sortOrder, _groups],
  (sortBy, sortOrder, groups) => {
    const sort = makeSortGroups(sortBy, sortOrder)

    return values(groups)
      .filter(g => !g.wasDeleted)
      .sort(sort)
  },
)

export const slicedFilteredGroups = createSelector(
  [filterGroups, limit, _page],
  (filterGroups, limit, page) => {
    return filterGroups.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

export const calculatePagination = createSelector(
  [filterGroups, limit, _page],
  (filteredGroups, limit, page) => {
    return {
      page,
      pages: Math.ceil(filteredGroups.length / limit),
      total: filteredGroups.length,
    }
  },
)
